import { supabase } from '../lib/supabase';

export const supplierService = {
  async getAll() {
    const { data, error } = await supabase?.from('suppliers')?.select(`
        id,
        name,
        email,
        phone,
        cnpj,
        razao_social,
        address,
        notes,
        created_at,
        updated_at
      `)?.order('created_at', { ascending: false })?.limit(200);

    if (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }

    return data;
  },

  async getById(id) {
    const { data, error } = await supabase?.from('suppliers')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return data;
  },

  async create(supplierData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('suppliers')?.insert({
        name: supplierData?.name,
        email: supplierData?.email,
        phone: supplierData?.phone,
        cnpj: supplierData?.cnpj,
        razao_social: supplierData?.razaoSocial,
        address: supplierData?.address,
        notes: supplierData?.notes,
        created_by: user?.id
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async update(id, updates) {
    const dbUpdates = {
      name: updates?.name,
      email: updates?.email,
      phone: updates?.phone,
      cnpj: updates?.cnpj,
      razao_social: updates?.razaoSocial !== undefined ? updates?.razaoSocial : updates?.razao_social,
      address: updates?.address,
      notes: updates?.notes
    };

    Object.keys(dbUpdates)?.forEach(key => {
      if (dbUpdates?.[key] === undefined) {
        delete dbUpdates?.[key];
      }
    });

    const { data, error } = await supabase?.from('suppliers')?.update(dbUpdates)?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async delete(id) {
    const { error } = await supabase?.from('suppliers')?.delete()?.eq('id', id);

    if (error) throw error;
  }
};